<template>
  <div>
    <!-- 詢價需求單查詢 -->
    <CCard class="w-100">
      <CCardHeader>
        <strong>詢價單查詢</strong>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <div class="CForminline">
            <div class="date_range">
              <p>{{ $t("SearchBar_Vue.StartDateBeginText") }}：</p>
              <date-picker
                :lang="'zh-tw'"
                v-model="searchParam.CreateTimeStart"
                format="YYYY-MM-DD"
                valueType="format"
              ></date-picker>
              <span>~</span>
              <date-picker
                :lang="'zh-tw'"
                v-model="searchParam.CreateTimeEnd"
                format="YYYY-MM-DD"
                valueType="format"
                :disabled-date="
                  (date) => date <= new Date(searchParam.CreateTimeStart)
                "
              ></date-picker>
            </div>

            <div class="number_range">
              <p>{{ $t("Request_Vue.QuoteNoIntervalText") }}：</p>
              <input
                type="text"
                maxlength="12"
                v-model="searchParam.InquiryNoStart"
                @change="checkInquiryNo"
              />
              <span>~</span>
              <input
                type="text"
                maxlength="12"
                v-model="searchParam.InquiryNoEnd"
                @change="checkInquiryNo"
              />
            </div>

            <div class="inquiry_name">
              <p>{{ $t("Request_Vue.InquiryName") }}：</p>
              <input
                type="text"
                maxlength="15"
                v-model="searchParam.InquiryName"
              />
            </div>

            <div class="purchase">
              <p>{{ $t("Request_Vue.Purchaser") }}：</p>
              <input
                type="text"
                maxlength="15"
                v-model="searchParam.Purchase"
              />
            </div>

            <div class="status_code">
              <p>{{ $t("Request_Vue.Status") }}：</p>
              <div
                v-for="(item, key) in supplierStatusList"
                :key="'statusCode_input_' + key"
              >
                <input
                  type="radio"
                  name="statusCode_input"
                  v-model="searchParam.Status"
                  :value="item.supplierStatusId"
                />{{ item.supplierStatusCaption }}
              </div>
            </div>

            <div class="btn_group">
              <button
                type="button"
                class="btn btn-edit mr-2"
                @click="searchDataEvent"
              >
                {{ $t("Buttons.Query") }}
              </button>
            </div>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      searchParam: {
        CreateTimeStart: "",
        CreateTimeEnd: "",
        InquiryNoStart: "",
        InquiryNoEnd: "",
        InquiryName: "",
        Purchase: "",
        Status: "廠商報價中",
      },
      supplierStatusList: this.$t("supplierStatusList"), //狀態碼 清單
    };
  },
  props: {},
  watch: {
    lang: function () {
      this.supplierStatusList = this.$t("supplierStatusList"); //狀態碼 清單
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["lang"]),
  },
  methods: {
    checkInquiryNo() {
      if (this.searchParam.InquiryNoStart > this.searchParam.InquiryNoEnd) {
        this.searchParam.InquiryNoEnd = "";
      }
    },

    //檢核條件
    checkSearchParam() {
      const {
        CreateTimeStart,
        CreateTimeEnd,
        DeadlineBegin,
        DeadlineEnd,
        InquiryNoStart,
        InquiryNoEnd,
      } = this.searchParam;
      let errMsg = "";
      if (CreateTimeStart && CreateTimeEnd) {
        if (CreateTimeStart > CreateTimeEnd) {
          errMsg = "開單日期區間錯誤，起始日不得大於終止日!";
        }
      }
      if (DeadlineBegin && DeadlineEnd) {
        if (DeadlineBegin > DeadlineEnd) {
          errMsg = "截止日期區間錯誤，起始日不得大於終止日!";
        }
      }
      if (InquiryNoStart && InquiryNoEnd) {
        if (InquiryNoStart > InquiryNoEnd) {
          errMsg = "單號區間錯誤，起始單號不得大於終止單號!";
        }
      }
      if (errMsg) {
        this.$alert(errMsg, "警告", { type: "warning" });
        return false;
      }
      return true;
    },

    //按鈕呼叫查詢觸發事件
    searchDataEvent() {
      if (!this.checkSearchParam()) {
        return;
      }
      if (!this.searchParam.InquiryNoEnd) {
        this.searchParam.InquiryNoEnd = this.searchParam.InquiryNoStart;
      }
      this.$emit("doSearchEvent", this.searchParam);
    },
  },
  created() {
    this.searchDataEvent();
  },
};
</script>

<style lang="scss" scoped>
.CForminline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  > .form-group {
    margin-bottom: 0;
  }

  > .date_range,
  .number_range,
  .quotation_class,
  .inquiry_name,
  .creator,
  .applicant_unit,
  .purchase,
  .status_code,
  .closure {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    > p {
      margin-right: 1rem;
      margin-bottom: 0;
    }
    > .purchase_input {
      margin-bottom: 0;
    }
    > input {
      margin: 0 0.5rem;
    }
    > div {
      margin: 0 0.5rem;
    }
  }
}

.purchase {
  width: 100%;
}

.btn-edit {
  background-color: #343b55;
  color: white;
}

@media screen and (max-width: 575px) {
  .CForminline {
    > .date_range,
    .number_range,
    .quotation_class,
    .inquiry_name,
    .creator,
    .applicant_unit,
    .purchase,
    .status_code,
    .closure {
      display: block;
      width: 100%;
      > input {
        width: 100%;
        margin: 0;
      }
      > div {
        margin: 0;
      }
      .mx-datepicker {
        width: 100%;
      }
    }
  }
}
</style>
